import React from "react";
import { Box, Typography } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { tokens } from "../../theme";
import { mockSidebarData } from "../../data/mockSidebarData";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography color="text.primary">{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const DashboardSidebarPages = ({
  isCollapsed,
  selected,
  setSelected,
  userRole,
}) => (
  <Box paddingLeft={isCollapsed ? undefined : "10%"}>
    <Item
      title="Dashboard"
      to="/dashboard"
      icon={<HomeOutlinedIcon />}
      selected={selected}
      setSelected={setSelected}
    />
    {mockSidebarData(userRole).map(
      (section, index) =>
        section.items.some(
          (item) => item.condition === undefined || item.condition
        ) && (
          <Box key={index}>
            <Typography variant="h6" color="text.primary" m="10px 0 5px 20px">
              {section.title}
            </Typography>
            {section.items.map(
              (item, idx) =>
                (item.condition === undefined || item.condition) && (
                  <Item
                    key={idx}
                    title={item.title}
                    to={item.to}
                    icon={item.icon}
                    selected={selected}
                    setSelected={setSelected}
                  />
                )
            )}
          </Box>
        )
    )}
  </Box>
);

export default DashboardSidebarPages;
